import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { fundFilters } from './fund.filters';

// `validateSearch` das rotas de Cessionários (U07). Leve de propósito: é JS inicial.

/** Sheet aberto na URL (`?sheet=`, U26): filtros no iPhone, ações da linha. */
const sheet = z.string().min(1).max(40).optional().catch(undefined);

/** `/cadastro/fundos`: página (a partir de 1), tamanho, ordem e os filtros do legado. */
export const fundListSearch = listSearchSchema({ ...fundFilters.shape, sheet });
export type FundListSearch = z.infer<typeof fundListSearch>;

/** Abas do cadastro na ordem do legado (U44); a primeira não vai para a URL. */
export const FUND_TABS = ['informacoes', 'envolvidos', 'documentos', 'cessoes'] as const;
export type FundTab = (typeof FUND_TABS)[number];

/** `/cadastro/fundos/$fundId`: aba (`?tab=`, U42) e o sheet aberto (envolvido, documento…). */
export const fundDetailSearch = z.object({
  tab: z.enum(FUND_TABS).optional().catch(undefined),
  sheet,
  /** Aba Cessões: página, tamanho e ordem da sublista. */
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  size: z.coerce.number().int().refine((value) => [5, 10, 15, 20].includes(value)).optional().catch(undefined),
  orderBy: z.string().regex(/^[A-Za-z][\w.]*_(ASC|DESC)$/).optional().catch(undefined),
});
export type FundDetailSearch = z.infer<typeof fundDetailSearch>;
